import Cookies from 'js-cookie';

interface PowerReward {
  userId: string;
  amount: number;
  reason: 'connect' | 'play' | 'share';
  timestamp: string;
  walletAddress?: string;
}

const REWARD_COOKIE_PREFIX = 'gbp_reward_';
const COOKIE_EXPIRY = 365; // 1년

export const hasReceivedReward = (userId: string, reason: PowerReward['reason']): boolean => {
  return !!Cookies.get(`${REWARD_COOKIE_PREFIX}${userId}_${reason}`);
};

export const markRewardAsReceived = (userId: string, reason: PowerReward['reason']): void => {
  Cookies.set(
    `${REWARD_COOKIE_PREFIX}${userId}_${reason}`, 
    'true', 
    { expires: COOKIE_EXPIRY }
  );
};

export const submitPowerReward = async (reward: PowerReward): Promise<boolean> => {
  if (hasReceivedReward(reward.userId, reward.reason)) {
    console.log('Reward already received:', reward);
    // return false;
  }
  try {
    const requestBody: { user_id: string; wallet_address?: string } = {
      user_id: reward.userId,
    };

    if (reward.walletAddress) {
      requestBody.wallet_address = reward.walletAddress;
    }

    const response = await fetch(`https://kaiko.retrofun.club/points/${reward.reason}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (response.ok) {
      console.log('Power reward submitted:', reward);
      markRewardAsReceived(reward.userId, reward.reason);
      return true;
    } else {
      const errorResponse = await response.json();
      console.error('Failed to submit power reward:', errorResponse.message);
      return false;
    }
  } catch (error) {
    console.error('Failed to submit power reward:', error);
    return false;
  }
};